export default __webpack_public_path__ + "static/media/PermianMiner.bdc9954e.png";